import { Component, Input } from '@angular/core';
import { JioTvPlanservice } from 'src/app/pages/jiotvplans/jiotvplans.service';

@Component({
    selector: 'app-ta-type-plans',
    templateUrl: './ta-type-plans.component.html',
    styleUrls: ['./ta-type-plans.component.scss'],
})
export class TaTypePlansComponent {
    @Input() callbackData: any;
    subType: boolean = true;
    isItem: boolean = false;

    constructor(JioTv: JioTvPlanservice) {}

    editBtnAction() {
        if (this.callbackData) {
            this.callbackData[0].callback(this.callbackData[0].arg[0], this.callbackData[0].arg[1]);
        }
    }

    listBtnAction() {
        if (this.callbackData) {
            this.callbackData[1].callback(this.callbackData[1].arg[0], this.callbackData[1].arg[1]);
        }
    }
}
